import { useSelector } from 'react-redux';
import ModuleInfo from '../components/ModuleInfo/ModuleInfo';
import TrainingCard from '../components/TrainingCard/TrainingCard';
import logo from '../logo.svg';
import { State } from '../state';
import './TrainingLanding.css';

const TrainingLanding: React.FC = () => {
    
    const { trainingState } = useSelector((state: State) => state)
    
    const otherTrainingCards = trainingState.currentTraining?.recommendedModules.map((module, index) => {
        return (
            <TrainingCard 
                key={index} 
                module={module} 
                small={true}
            />
        )
    })
    return (
        <div className="TrainingLanding">
            <img src={logo} className="App-logo" alt="logo" />
            {/* TBD: Once the training page is built, since Scanning Sutures and Order Management only have a single submodule, 
                then I'm thinking I'll ternary on the below line and point those to modules directly to the training page with their single submodule loaded up */}
            {trainingState.currentTraining &&
                <>
                    <ModuleInfo training={trainingState.currentTraining} />
                    <div className="otherTrainingContainer">
                        <span>OTHER AREAS OF TRAINING</span>
                        <div className="trainingCardContainer">
                            {otherTrainingCards}
                        </div>
                    </div>
                </>
            }
        </div>
    );
}

export default TrainingLanding;